jQuery(document).ready(function($) {
    const $block = $('.wp-block-jormi-blocks-offset-text');
    
    if ($block.length) {
      
      $block.each(function() {
        const $currentBlock = $(this);
        
        // Step 1: Wrap words, including <em>
        function wrapWordsInSpans() {
          const $h1 = $currentBlock.find('h2:not(.sr-only)');
          
          function wrapWords(node) {
            if (node.nodeType === 3) { // Text node
              const wrapper = document.createElement('span');
              wrapper.innerHTML = node.textContent.replace(/(\S+)/g, '<span class="word">$1</span>');
              node.replaceWith(wrapper);
            } else if (node.nodeType === 1) { // Element node
              const childNodes = [...node.childNodes];
              childNodes.forEach(child => wrapWords(child));
            }
          }
  
          if ($h1.length) {
            const childNodes = [...$h1[0].childNodes];
            childNodes.forEach(node => wrapWords(node));
          }
        }
  
        // Step 2: Wrap letters in all words
        function wrapLettersInWords() {
          $currentBlock.find('.word').each(function() {
            const text = $(this).text();
            const wrappedText = text.split('').map(letter => {
              return letter === ' ' ?
                `<span class="letter">&nbsp;</span>` :
                `<span class="letter">${letter}</span>`;
            }).join('');
            $(this).html(wrappedText);
          });
        }
  
        // Step 3: Check overlap for all words and letters
        function checkOverlap() {
          const $img = $currentBlock.find('img');
          
          if (!$img.length) return;
          
          const imgRect = $img[0].getBoundingClientRect();
          
          $currentBlock.find('.word').each(function() {
            const wordRect = this.getBoundingClientRect();
            
            if (wordRect.right > imgRect.left &&
                wordRect.left < imgRect.right &&
                wordRect.bottom > imgRect.top &&
                wordRect.top < imgRect.bottom) {
              
              $(this).find('.letter').each(function() {
                const letterRect = this.getBoundingClientRect();
                
                if (letterRect.right > imgRect.left &&
                    letterRect.left < imgRect.right &&
                    letterRect.bottom > imgRect.top &&
                    letterRect.top < imgRect.bottom) {
                  $(this).addClass('inverse');
                } else {
                  $(this).removeClass('inverse');
                }
              });
            } else {
              $(this).find('.letter').removeClass('inverse');
            }
          });
        }
  
        // Init
        wrapWordsInSpans();
        wrapLettersInWords();
        checkOverlap();
  
        // Watch resize
        $(window).on('resize', _.debounce(checkOverlap, 150));
      });
    }
  });